import React from 'react'
import { EVENT_TYPES, TIME_FORMAT } from '../../../constants'
// eslint-disable-next-line no-unused-vars
import { IEvent } from '../../../types'
import {
  convertType,
  customDateFormat,
  isDisplayIcon,
  convertTypeDisable
} from '../../../utils'
import styles from '../SAPPCalendar.module.css'
import CustomTooltip from '../common/CustomTooltip'
import { getIconforEvent } from '../../../icons'

interface IMonthlyEventProps {
  event: IEvent
  isSameMonth: boolean
  onEventDetail?: (event: IEvent) => void
}

const MonthlyEvent = ({
  event,
  isSameMonth,
  onEventDetail
}: IMonthlyEventProps) => {
  const formateTimeSchudule =  event.type === 'INACTIVE' ? 'D/M/YYYY' : TIME_FORMAT
  const formattedDate =
    customDateFormat(event.startDate, formateTimeSchudule) +
    ' - ' +
    customDateFormat(event.endDate, formateTimeSchudule)
  const formattedDateStart = customDateFormat(event.startDate, TIME_FORMAT)
  const iconList = getIconforEvent(event, event.isActive)
  const typeClass = event.isActive !== undefined ? (
    event.isActive === true
    ? convertType[event.type] || 'default'
    : convertTypeDisable[event.type] || 'default') : (convertType[event.type] || 'default')
  const className = event?.isOverDue
    ? `event-error`
    : isSameMonth
    ? `event-${typeClass}`
    : 'event-default'

  return (
    <React.Fragment>
      <li
        className={styles[className]}
        style={{ cursor: 'pointer' }}
        onClick={() => onEventDetail && onEventDetail(event)}
      >
        <div className={styles['monthly-event__title']}>
          {isDisplayIcon(event) && (
            <div className={styles['weekly-event__title_icon']}>{iconList}</div>
          )}
          <CustomTooltip title={event.title}>
            <div className={styles['truncate-text']}>{event.title}</div>
          </CustomTooltip>
        </div>
        <div className={styles['monthly-event__date']}>
          <CustomTooltip title={formattedDate}>{formattedDate}</CustomTooltip>
        </div>
        <div className={styles['monthly-event__date_tablet']}>
          {iconList}
          <CustomTooltip title={formattedDate}>
            {formattedDateStart}
          </CustomTooltip>
        </div>
      </li>
    </React.Fragment>
  )
}

export default MonthlyEvent
